import type { ITrustpilotRating, ITrustpilotRatingModel } from '@/modules/adminModule/types/trustpilotRating'
import { TrustpilotRatingFromJSON, TrustpilotRatingToJSON } from '@/modules/adminModule/models/trustpilotRating'

const groupPrefix = 'trustpilot-ratings'

export const apiTrustpilotRatings = {
	fetchTrustpilotRating: async () => {
		const { data } = await apiCommon<ITrustpilotRating>(`${groupPrefix}`, { method: 'GET', skipSSRPayload: true })
		return TrustpilotRatingFromJSON(data)
	},

	updateTrustpilotRating: async (ratingData: Partial<ITrustpilotRatingModel>) => {
		const { data } = await apiCommon<ITrustpilotRating>(`${groupPrefix}`, { method: 'PUT', body: TrustpilotRatingToJSON(ratingData) })
		return TrustpilotRatingFromJSON(data)
	},
}
